import { afterEvent, cardRef, defineGameCard } from '../authoring/index.js';
import { applyThorns, hasTrait, isLiveOnBoard, PLANT_GROWTH_ID, tableOf, } from './plant-helpers.js';
/**
 * Живой терновник реагирует на первую фактическую прибавку Роста своему
 * Растению в локации: ставит Колючки напротив пустой ячейки либо ранит
 * находящуюся там карту.
 */
export const LivingThornbushCard = defineGameCard({
    id: 'living_thornbush',
    gameplay: {
        type: 'STRUCTURE',
        cost: 2,
        baseStats: { attack: 0, health: 4 },
        traits: ['PLANT'],
    },
    presentation: {
        name: 'Живой терновник',
        description: 'Первый раз за раунд, когда ваше Растение в этой локации получает Рост: если ячейка напротив него пуста, наложите туда Колючки 1; иначе нанесите находящейся там карте 1 урон.',
        glyph: {
            colors: ['#303A2B', '#10213A', '#263026', '#545239', '#3E4632'],
            rows: [
                '....................',
                '....................',
                '...........1........',
                '.....1....1.........',
                '.....1...21...2.....',
                '..1...1..22...1.1...',
                '...1..23.421..22....',
                '.1.1.214.33..14....1',
                '.3351..3333...1..12.',
                '1...31..243.1.41.1..',
                '.33.332.353..4..1221',
                '..5..22.353..2.11...',
                '2252.242245.3333...2',
                '...25544.322543511..',
                '..1..25523343..11...',
                '....1.22423233......',
                '........2232........',
                '.......24212........',
                '.....244544442......',
                '......2222222.......',
            ],
        },
    },
    role: 'playable',
    abilities: [
        afterEvent({
            abilityId: 'growth_sting',
            event: 'EffectCounterChanged',
            frequency: 'first_per_round',
            when: (ctx, event) => {
                const self = ctx.self;
                if (!isLiveOnBoard(self)
                    || event.defId !== PLANT_GROWTH_ID
                    || event.key !== 'growth'
                    || event.delta <= 0
                    || event.scope.kind !== 'unit')
                    return false;
                const plant = ctx.q.instance(event.scope.instanceId);
                return isLiveOnBoard(plant)
                    && plant.controllerId === self.controllerId
                    && tableOf(plant.cellId) === tableOf(self.cellId)
                    && hasTrait(ctx, plant.id, 'PLANT');
            },
            run: {
                source: 'card_effect',
                dependencies: [cardRef(PLANT_GROWTH_ID), cardRef('plant_thorns')],
                run: (ctx, ...args) => {
                    const event = args[0];
                    if (event.scope.kind !== 'unit')
                        return;
                    const plant = ctx.q.instance(event.scope.instanceId);
                    if (!isLiveOnBoard(plant))
                        return;
                    const opposite = ctx.q.opposingCell(plant.cellId);
                    if (opposite === null)
                        return;
                    if (opposite.occupantId === null) {
                        applyThorns(ctx, opposite.id, 1, plant.controllerId);
                    }
                    else {
                        ctx.ops.dealDamage({ kind: 'unit', instanceId: opposite.occupantId }, 1);
                    }
                },
            },
        }),
    ],
    ui: { mechanics: ['growth', 'thorns'] },
});
//# sourceMappingURL=living_thornbush.js.map